import React from "react";
import { useSector } from "./SectorContext";
import { useNavigate } from "react-router-dom";

function AltPortfolioSection() {
  const { activeSector, openProject, selectedSector } =
    useSector();
  const projects = activeSector.projects;

  const navigate = useNavigate();

 

  return (
    <section className="alt-portfolio-section">
      <div className="alt-portfolio-wrapper">
        <div className="alt-portfolio-heading">
          <h2 className={activeSector.colorClass}>{selectedSector === "advertising" ? "#Work" : "/Projects/"}</h2>
        </div>
        <div className="alt-projects-container">
          {/*Maps project data to project tiles. */}
          {/*Maps project data to project tiles. */}
          {projects.map((project, index) => (
            <div
              key={project.projName}
              className={`alt-project-tile ${activeSector.colorClass} ${
                index % 2 === 0 ? "corner-top-left" : "corner-bottom-right"
              }`}
            >
              <span className="corner-accent"></span>
              <div className="alt-project-tile-inner">
                <div className="alt-info-wrapper">
                  <div className="alt-project-headline">
                    {project.projHeadline}
                  </div>
                  <div className="alt-project-description">
                    {project.projOverview}
                  </div>
                  <div
                    className="alt-see-more underline-first"
                    // Sends the current state to the intended destination.
                    onClick={() => {
                      openProject(project);
                      navigate("/project");
                    }}
                  >
                    See Project
                  </div>
                </div>

                <div className="alt-project-thumbnail">
                  <img
                    src={project.projHeroImage}
                    alt={`${project.projName} project preview`}
                    loading="lazy"
                    decoding="async"
                  />
                  {/* <img src="jetimage.png" alt="project-thumbnail" /> */}
                </div>
              </div>
            </div>
          ))}
        </div>{" "}
      </div>
    </section>
  );
}

export default AltPortfolioSection;
